var map = {
	"./Adjectives": [
		33822,
		3822
	],
	"./Adjectives.json": [
		33822,
		3822
	],
	"./Adverbs": [
		28799,
		8799
	],
	"./Adverbs.json": [
		28799,
		8799
	],
	"./AnimalsBabiesSoundsGroups": [
		45483,
		5483
	],
	"./AnimalsBabiesSoundsGroups.json": [
		45483,
		5483
	],
	"./Articles": [
		57669,
		7669
	],
	"./Articles.json": [
		57669,
		7669
	],
	"./BasicTenses": [
		20200,
		200
	],
	"./BasicTenses.json": [
		20200,
		200
	],
	"./Comprehension": [
		20950,
		950
	],
	"./Comprehension.json": [
		20950,
		950
	],
	"./Conjunctions": [
		78327,
		8327
	],
	"./Conjunctions.json": [
		78327,
		8327
	],
	"./FeminineAndMasculine": [
		96815,
		6815
	],
	"./FeminineAndMasculine.json": [
		96815,
		6815
	],
	"./JumbledLetters": [
		76146,
		6146
	],
	"./JumbledLetters.json": [
		76146,
		6146
	],
	"./Nouns": [
		17271,
		7271
	],
	"./Nouns.json": [
		17271,
		7271
	],
	"./OddOneOut": [
		14687,
		4687
	],
	"./OddOneOut.json": [
		14687,
		4687
	],
	"./OneAndMany": [
		23692,
		3692
	],
	"./OneAndMany.json": [
		23692,
		3692
	],
	"./Opposites": [
		3000,
		3000
	],
	"./Opposites.json": [
		3000,
		3000
	],
	"./Prepositions": [
		63077,
		3077
	],
	"./Prepositions.json": [
		63077,
		3077
	],
	"./Pronouns": [
		33694,
		3694
	],
	"./Pronouns.json": [
		33694,
		3694
	],
	"./Punctuation": [
		53410,
		3410
	],
	"./Punctuation.json": [
		53410,
		3410
	],
	"./SpokenAndWrittenExpression": [
		2342,
		2342
	],
	"./SpokenAndWrittenExpression.json": [
		2342,
		2342
	],
	"./Verbs": [
		26904,
		6904
	],
	"./Verbs.json": [
		26904,
		6904
	],
	"./WordMeanings": [
		7030,
		7030
	],
	"./WordMeanings.json": [
		7030,
		7030
	],
	"./WordPairs": [
		64127,
		4127
	],
	"./WordPairs.json": [
		64127,
		4127
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 51543;
module.exports = webpackAsyncContext;